import {
  useAppDispatch,
  useAppSelector,
} from "@/app/lib/features/redux/redux.hook";
import { useCallback } from "react";
import { postWebVisit } from "./webVisit.thunk";
import { WebVisitPayload } from "./webVisit.types";

const useWebVisit = () => {
  const dispatch = useAppDispatch();
  const { logged, status } = useAppSelector((store) => store.webVisit);

  const logVisit = useCallback(
    (data: WebVisitPayload) => {
      dispatch(postWebVisit(data));
    },
    [dispatch],
  );

  return {
    logged,
    status,
    logVisit,
  };
};

export default useWebVisit;
